import { helper } from '@ember/component/helper';

// Regex pre-compilata per performance
const BR_REGEX = /<br\s*\/?>/gi;

/**
 * Sostituisce i tag <br> con virgole
 */
var replaceBr2comas = helper(([input]) => typeof input === 'string' ? input.replace(BR_REGEX, ', ') : '');

export { replaceBr2comas as default };
//# sourceMappingURL=replace-br2comas.js.map
